import { useState } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);
  const testimonial = testimonials[current];

  const prev = () => {
    setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  };

  const next = () => {
    setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));
  };

  return (
    <section className="bg-background-100 py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="w-full max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-10 md:mb-14">
          （读者真实评价）
        </h2>

        <div className="text-left">
          <div className="flex items-center gap-2 mb-6">
            <div className="px-3 py-1.5 bg-foreground-900 text-background-50 rounded-full text-xs font-medium flex items-center gap-1.5">
              <i className="ri-star-fill text-accent-500" />
              <span>{testimonial.rating}</span>
            </div>
          </div>

          <blockquote className="font-heading text-lg md:text-xl text-foreground-800 leading-relaxed mb-8">
            "{testimonial.quote}"
          </blockquote>

          <div className="flex items-center gap-3">
            <img
              src={testimonial.avatar}
              alt={testimonial.author}
              className="w-12 h-12 rounded-full object-cover"
              loading="lazy"
            />
            <div>
              <p className="text-sm font-semibold text-foreground-900">
                {testimonial.author}
              </p>
              <p className="text-xs text-foreground-500">{testimonial.role}</p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 mt-10">
          <button
            onClick={prev}
            className="w-10 h-10 border border-foreground-300 flex items-center justify-center text-foreground-600 hover:bg-background-200 transition-colors"
            aria-label="上一条评价"
          >
            <i className="ri-arrow-left-line" />
          </button>
          <button
            onClick={next}
            className="w-10 h-10 bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors"
            aria-label="下一条评价"
          >
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}